export const ORDER_STATUS_ID = {
  PENDING: 260101,
  PRINTED: 260102,
  UPDATED: 260103,
  CANCELLED: 260104,
  PACKAGED: 260105,
  PARTIALLY_PACKAGED: 260106,
  REVIEW_REJECTED: 260107,
  REVIEW_APPROVED: 260108,
  SHIPPED: 260109,
  DELIVERED: 260110,
  PARTIALLY_DELIVERED: 260111,
  UNDELIVERED: 260112,
  CASH_COLLECTED: 260113,
  RETURN_PRODUCT_RECEIVED: 260114,
  COMPLETED: 260115,
} as const;

export const ORDER_STATUS_TITLES: Record<number, { titleEn: string; titleAr: string }> = {
  260101: { titleEn: 'Pending', titleAr: 'قيد الانتظار' },
  260102: { titleEn: 'Printed', titleAr: 'تمت الطباعة' },
  260103: { titleEn: 'Updated', titleAr: 'تم التحديث' },
  260104: { titleEn: 'Cancelled', titleAr: 'ملغي' },
  260105: { titleEn: 'Packaged', titleAr: 'تم التغليف' },
  260106: { titleEn: 'Partially Packaged', titleAr: 'تم التغليف جزئياً' },
  260107: { titleEn: 'Review Rejected', titleAr: 'مرفوض من المراجع' },
  260108: { titleEn: 'Review Approved', titleAr: 'معتمد من المراجع' },
  260109: { titleEn: 'Shipped', titleAr: 'تم الشحن' },
  260110: { titleEn: 'Delivered', titleAr: 'تم التوصيل' },
  260111: { titleEn: 'Partially Delivered', titleAr: 'تم التوصيل جزئياً' },
  260112: { titleEn: 'Undelivered', titleAr: 'لم يتم التوصيل' },
  260113: { titleEn: 'Cash Collected', titleAr: 'تم تحصيل النقدية' },
  260114: { titleEn: 'Return Product Received', titleAr: 'تم استلام المرتجع' },
  260115: { titleEn: 'Completed', titleAr: 'مكتمل' },
};

export const ORDER_STATUS_ID_TO_KEY: Record<number, string> = {
  260101: 'pending',
  260102: 'printed',
  260103: 'updated',
  260104: 'cancelled',
  260105: 'packaged',
  260106: 'partially_packaged',
  260107: 'rejected',
  260108: 'approved',
  260109: 'shipped',
  260110: 'delivered',
  260111: 'partially-delivered',
  260112: 'undelivered',
  260113: 'cash-collected',
  260114: 'return-product-received',
  260115: 'completed',
};

export const ORDER_STATUS_ID_TO_COLOR_CLASS: Record<number, string> = {
  260101: 'bg-status-warning', // Pending
  260102: 'bg-status-info', // Printed
  260103: 'bg-status-info', // Updated
  260104: 'bg-status-neutral', // Cancelled
  260105: 'bg-status-info', // Packaged
  260106: 'bg-status-warning', // Partially Packaged
  260107: 'bg-status-danger', // Review Rejected
  260108: 'bg-status-success', // Review Approved
  260109: 'bg-status-info', // Shipped
  260110: 'bg-status-success', // Delivered
  260111: 'bg-status-info', // Partially Delivered
  260112: 'bg-status-danger', // Undelivered
  260113: 'bg-status-success', // Cash Collected
  260114: 'bg-status-info', // Return Product Received
  260115: 'bg-status-success', // Completed
};

export const ORDER_STATUS_DEFAULT_COLOR_CLASS = 'bg-status-neutral';
